import { useEffect, useState } from "react";

import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const HelpText = ({ id, text, size, setState }) => {
  const [type, setType] = useState("");
  const [transformedText, setTransformedText] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    if (!type) return;

    setState(type);

    const element = document.querySelector(`input#${id}`);

    if (element) element.focus();

    return () => setState();
  }, [type, setState, id]);

  useEffect(() => {
    const isObject = text.includes("{") && text.includes("}");
    if (isObject) {
      const objectFromText = JSON.parse(text);
      setTransformedText(objectFromText.message);
      return setType(objectFromText.type);
    }

    setTransformedText(text);
  }, [text]);

  const getIcon = (type) => {
    const iconColor = S.color({ type, theme });

    switch (type) {
      case "warning":
      case "success":
        return (
          <GetIcon
            type="solid"
            name="CheckCircle"
            size={size}
            color={iconColor}
          />
        );

      default:
        return (
          <GetIcon
            type="solid"
            name="InfoCircle"
            size={size}
            color={iconColor}
          />
        );
    }
  };

  return (
    <S.Text type={type} size={size}>
      {getIcon(type)}
      <p>{transformedText}</p>
    </S.Text>
  );
};

export default HelpText;
